<style lang="less" scoped>
  .content {
    flex-direction: column;
  }
  .table-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 80px;
  }
  .table-area {
    height: 180px;
  }
  .arrow-row {
    padding: 8px 0;
    text-align: center;
    position: relative;
    min-height: 45px;
  }
  .progress {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .number-layout {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .number {
      position: absolute;
      font-size: 84px;
      padding: 0 16px;
      &:nth-of-type(1),
      &:nth-of-type(3) {
        font-size: 36px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff800;
        opacity: 0.5;
        top: 50%;
        transform: translateY(-50%)
      }
      &:nth-of-type(1) {
        left: 0;
      }
      &:nth-of-type(3) {
        right: 0;
      }
    }
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-recall='recall')
    .content
      .table-layout
        .up-arrow.arrow-row
          up-arrow-component(
            @click.native='prevPage'
            v-if='page > 0')
          progress-component.progress(
            :current='current + 1'
            :max='answerCount'
            :unit='"자리"')
        .table-area
          table-component(
            :page='page'
            :units='units'
            :width='numberFontSize'
            :input='answer'
            :focus='focus'
            @click-column='setCurrent($event + (page * colsCount))')
        .down-arrow.arrow-row
          down-arrow-component(
            @click.native='nextPage'
            v-if='page < groupCount - 1')
      .number-layout
        number-component.number(
          v-for='data in display'
          :data='data')
    .footer
      footer-component(
        :time='time'
        @click-next='next'
        @click-prev='prev')
</template>

<script>
import HeaderComponent from '@/components/header/header_recall';
import ProgressComponent from '@/components/current_max_progress';
import UpArrowComponent from '@/components/up_arrow';
import DownArrowComponent from '@/components/down_arrow';
import TableComponent from '@/components/number_table';
import NumberComponent from '@/components/number_display';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      time: 0,
      page: 0,
      current: 0,
      rows: 4,
      cols: 6,
    };
  },
  methods: {
    recall() {
      // 외울 때 걸린 시간은 최종 성적에 영향을 줌.
      // 하지만 기준시간으로 측정하기 때문에 고정값.
      // this.$store.commit('setUsedTime', this.time);
      this.$router.replace({ name: 'TrainingNumberRecall' });
    },
    redirectBack() {
      this.$router.go(-1);
    },
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.recall();
      }
    },
    next() {
      if (this.current + 1 < this.answer.length) {
        this.current += 1;
        this.page = Math.floor(this.current / this.colsCount);
      }
    },
    prev() {
      if (this.current - 1 >= 0) {
        this.current -= 1;
        this.page = Math.floor(this.current / this.colsCount);
      }
    },
    nextPage() {
      if (this.page + 1 < this.groupCount) {
        this.page += 1;
        this.current = this.page * this.colsCount;
      }
    },
    prevPage() {
      if (this.page - 1 >= 0) {
        this.current = (this.page * this.colsCount) - 1;
        this.page -= 1;
      }
    },
    setCurrent(index) {
      this.current = index;
    },
  },
  mounted() {
    window.intervalID = setInterval(this.progressTimer, 1000);
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  computed: {
    colsCount() {
      return this.rows * this.cols;
    },
    numberFontSize() {
      let size = 16;
      switch (this.units) {
        case 1:
          size = 16;
          break;
        case 2:
          size = 14;
          break;
        case 3:
          size = 12;
          break;
        default:
      }
      return size;
    },
    focus() {
      return this.current % this.colsCount;
    },
    units() {
      return this.$store.state.app.units;
    },
    answer() {
      return this.$store.state.app.answer;
    },
    endTime() {
      return this.$store.state.app.time * 60;
    },
    grouping() {
      const count = this.answerCount;
      // const grouped = Math.ceil(count / this.colsCount);
      const result = [];
      for (let i = this.colsCount * this.page; i < (this.colsCount * this.page) + this.colsCount; i += 1) {
        if (i >= count) {
          break;
        }
        result.push(this.answer[i]);
      }
      return result;
    },
    groupCount() {
      const groupCount = Math.ceil(this.answer.length / this.colsCount);
      return groupCount;
    },
    answerCount() {
      return this.answer.length;
    },
    display() {
      const result = [];
      let index = 0;
      for (let i = this.current - 1; i <= this.current + 1; i += 1) {
        if (this.answer[i]) {
          result[index] = this.answer[i];
        }
        index += 1;
      }
      return result;
    },
  },
  components: {
    HeaderComponent,
    ProgressComponent,
    UpArrowComponent,
    DownArrowComponent,
    TableComponent,
    NumberComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/number/start.vue